import { FC } from 'react';
import { Modal } from 'antd';
import AddNutMaterial from './addNutMaterial';
import NutMaterialList from './NutMaterialList';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadNutMaterials } from './NutMaterialSlice';
import { CommonContext, CommonContextType } from '../../contexts/CommonContext';
import { AppState } from '../../redux/store/rootReducer';
const NutMaterialPage: FC = () => {
  const dispatch = useDispatch();
  const { isModalOpen, setModelChange, contextHolder, setEditBodySize, editBodySize } = React.useContext(CommonContext) as CommonContextType;
  const NutMaterials = useSelector(
    (state: AppState) => state.NutMaterials
  );
  const showModal = () => {
    setModelChange(true);
  };
  const handleCancel = () => {
    setEditBodySize(null)
    setModelChange(false);
  };

  React.useEffect(() => {
    dispatch(loadNutMaterials());
  }, [dispatch]);
  return (
    <div className='padding' style={{ background: '#ffffff' }}>
      {contextHolder}
      <br></br>
      <h2>Nut Material List
        <button className='top-button' onClick={showModal}>Create</button>
      </h2>
      <br></br>
      <NutMaterialList />
      <Modal title={editBodySize?.id ? 'Edit Nut Material' : 'Create Nut Material'} open={isModalOpen} onCancel={handleCancel} maskClosable={false} footer={null}>
        <AddNutMaterial />
      </Modal>
    </div>
  );

};

export default NutMaterialPage;